import ajax from '../utils/request';

const angentApi = {
  /***************************金币流水管理****************************** */
  // 获取用户推广日志
  getExtensionList(params) {
    return ajax({
      url: '/proxy/log',
      type: 'get',
      params: params
    });
  },
  // 获取用户推广查询列表
  getUserExtensionList(parmas) {
    return ajax({
      url: '/proxy/promotion',
      type: 'get',
      params: parmas
    });
  },

  /***************************代理列表****************************** */
  // 代理列表配置
  getProxyList(params) {
    return ajax({
      url: '/proxy/totalIncome',
      type: 'get',
      params: params
    });
  },
  // 代理列表详情记录
  getProxyDetails(params) {
    return ajax({
      url: '/proxy/income/details',
      type: 'get',
      params: params
    });
  },

  /*************************** 邀请积分配置 ****************************** */
  getInvitationIncomeConfList(params) {
    return ajax({
      url: '/invitationIncomeConf/list',
      type: 'get',
      params: params
    });
  },
  updateInvitationIncomeConf(params) {
    return ajax({
      url: '/invitationIncomeConf/update',
      type: 'post',
      params: params
    });
  },
  createInvitationIncomeConf(params) {
    return ajax({
      url: '/invitationIncomeConf/create',
      type: 'post',
      params: params
    });
  },
  delInvitationIncomeConf(params) {
    return ajax({
      url: '/invitationIncomeConf/delete',
      type: 'post',
      params: params
    });
  }
};


export default angentApi;
